import { useContext } from "react";
import PropTypes from "prop-types";
import { updateStatusApi } from "Apis/utils";
import { LoginFormContext } from "context/LoginFormContext";
import { ModalContext } from "context/ModalContext";
import SubmitButton from "components/SubmitButton";
import colors from "assets/theme/base/colors";

const UpdateStatus = ({ tableNameProp, data, access }) => {
  const { setNotification } = useContext(LoginFormContext);
  const { showMessageNotification } = useContext(ModalContext);
  const { success, error } = colors;

  const handleStatusChange = async () => {
    const updatedData = { ...data.original };
    let message = "";

    if (updatedData?.is_active === 1) {
      updatedData.is_active = 0;
      message = "Record has been inactivated successfully.";
    } else {
      updatedData.is_active = 1;
      message = "Record has been activated successfully.";
    }

    const { id, is_active } = updatedData;
    showMessageNotification({
      title: "Are you sure?",
      text: "You want to change the status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        data.original.is_active = updatedData.is_active;
        let response = await updateStatusApi({
          id,
          is_active,
          tableName:
            tableNameProp === "banners"
              ? tableNameProp
              : updatedData.type
                ? updatedData.type
                : tableNameProp,
        });

        if (response?.status === 200) {
          setNotification({
            color: "success",
            icon: "check",
            title: "Success",
            content: message,
            open: true,
          });
        } else {
          data.original.is_active = is_active === 1 ? 0 : 1;
          setNotification({
            color: "error",
            icon: "cancel",
            title: "Error",
            content: message,
            open: true,
          });
        }
      }
    });
  };

  return (
    <SubmitButton
      onClick={access ? handleStatusChange : null}
      background={data?.original?.is_active === 1 ? success.main : error.main}
      hoverBackground={data?.original?.is_active === 1 ? success.hover : error.hover}
      color="#fff"
      btnText={data?.original?.is_active === 1 ? "Active" : "Inactive"}
      type="button"
    >
      {data?.original?.is_active === 1 ? "Active" : "Inactive"}
    </SubmitButton>
  );
};

UpdateStatus.propTypes = {
  tableNameProp: PropTypes.string,
  data: PropTypes.object.isRequired,
  access: PropTypes.bool.isRequired,
};

export default UpdateStatus;
